import ReactDom from "react-dom";

export function Portal({ children }: { children: React.ReactNode }) {
  const el = document.getElementById("portal");
  if (!el) return null;
  return ReactDom.createPortal(children, el);
}
